import { http } from '@services/http';
import { setStorageServices } from '@utils/storage';

export const GET_SERVICES = 'GET_SERVICES';

export const getServices = () => async (dispatch) => {
  try {
    const response = await http.get('/services');
    const services = response.data;

    setStorageServices(services);

    dispatch({ type: GET_SERVICES, payload: services });
    return Promise.resolve(services);
  } catch (err) {
    return Promise.reject(err);
  }
};
